export default __webpack_public_path__ + "static/media/gcloud.f6acd9c2.png";